/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CreateBackupJobInput {
  /**
  * The ID of the resource
  */
  'resourceId': string;
  /**
  * The ID of the vault
  */
  'vaultId': string;
  /**
  * The number of days to retain the backup
  */
  'retentionDays': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceId",
      "baseName": "resourceId",
      "type": "string",
      "format": ""
    },
    {
      "name": "vaultId",
      "baseName": "vaultId",
      "type": "string",
      "format": ""
    },
    {
      "name": "retentionDays",
      "baseName": "retentionDays",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateBackupJobInput.attributeTypeMap;
  }

  public constructor() {
  }
}

